import axiosInstance from "./api";

export const getArticlesForSearch = async () => {
  try {
    const response = await axiosInstance.get("/articles/search");
    return response.data.articles || [];
  } catch (error) {
    console.error("Error fetching articles for search:", error);
    throw error;
  }
};

export const getArticleById = async (id) => {
  try {
    const response = await axiosInstance.get(`/articles/${id}`);
    return response.data.article;
  } catch (error) {
    console.error("Error fetching article by ID:", error);
    throw error;
  }
};

export const reactToArticle = async (articleId, reaction) => {
  try {
    const response = await axiosInstance.post(`/articles/${articleId}/react`, {
      reaction,
    });
    return response.data;
  } catch (error) {
    console.error("Error reacting to article:", error);
    throw error;
  }
};
